import { render, staticRenderFns } from "./EditOrderDetails.vue?vue&type=template&id=231dffb7&"
import script from "./EditOrderDetails.vue?vue&type=script&lang=js&"
export * from "./EditOrderDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports